import {ModuleComponent} from "../../js/module-component";
import {Cookies} from "../../js/cookies";

export class ModCookies extends ModuleComponent{
    ready() {
        super.ready();
        let  cookieN = "cookiesok";
        let  cookieV = "ok";

        let cookie= Cookies.read(cookieN);
        this.$cookies = this.$root;


        if (cookie != cookieV) {
            this.$cookies.css("display", "block");
        }
        this.$cookies.toggle(cookie != cookieV);

        this.$root.find(this.scope + "__accept-all").click(
            (ev) => {
                ev.preventDefault();
                Cookies.create(cookieN,cookieV, 365);
                this.$cookies.css("display", "none");
            }
        );

        this.$root.find(this.scope + '__confirm-config').click(
            (ev) => {
                ev.preventDefault();
                Cookies.create(cookieN, cookieV, 365);
                this.$cookies.css("display", "none");
            }
        );

        this.$root.find(this.scope + '__configure').click(
            (ev) => {
                ev.preventDefault();
                this.$cookies.find(this.scope + "__config").toggle();
            }
        );
    }
}